export var GraphStateType;
(function (GraphStateType) {
    GraphStateType[GraphStateType["Svg"] = 0] = "Svg";
    GraphStateType[GraphStateType["Image"] = 1] = "Image";
})(GraphStateType || (GraphStateType = {}));
